const env = process.env.REACT_APP_NODE_ENV;

let apiUrl = process.env.REACT_APP_API_URL_DEV;
let aiApiUrl = process.env.REACT_APP_AI_API_URL_DEV;
let stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
let webUrl = process.env.REACT_APP_WEB_URL_DEV;
let dashboardUrl = process.env.REACT_APP_DASHBOARD_URL_DEV;
let landingUrl = process.env.REACT_APP_LANDING_URL_DEV;
if (env === 'test') {
  apiUrl = process.env.REACT_APP_API_URL_TEST;
  aiApiUrl = process.env.REACT_APP_AI_API_URL_TEST;
  webUrl = process.env.REACT_APP_WEB_URL_TEST;
  dashboardUrl = process.env.REACT_APP_DASHBOARD_URL_TEST;
  landingUrl = process.env.REACT_APP_LANDING_URL_TEST;
} else if (env === 'prod') {
  apiUrl = process.env.REACT_APP_API_URL_PROD;
  aiApiUrl = process.env.REACT_APP_AI_API_URL_PROD;
  stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD;
  webUrl = process.env.REACT_APP_WEB_URL_PROD;
  dashboardUrl = process.env.REACT_APP_DASHBOARD_URL_PROD;
  landingUrl = process.env.REACT_APP_LANDING_URL_PROD;
}

const config = {
  env,
  apiUrl,
  webUrl,
  stripePublishableKey,
  aiApiUrl,
  dashboardUrl,
  landingUrl
}

export default config;
